// extracted by mini-css-extract-plugin
export default {"container":"_F-z","header":"aG-z","details":"bG-z","link":"cG-z"};